const doc = [({"ja":({"adminHotelOption":({"import":"取り込み"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;